<template>
  <component
    :is="Resolved"
    v-if="Resolved"
  />
  <div v-else>
    Loading...
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'HomeEntry',
  data() {
    return {
      Resolved: null,
    }
  },
  async created() {
    // token bor bo'lsa, user yo'q bo'lsa, yuklab olamiz
    if (store.getters['auth/isAuthenticated'] && !store.state.auth.user) {
      try {
        await store.dispatch('auth/fetchUser')
      } catch (e) {
        // xohlasangiz login ga redirect ham qilsa bo'ladi
      }
    }

    const roleId = store.state.auth.user?.role_id ?? null

    // Role bo'yicha kerakli componentni LAZY import qilamiz
    // Role ID larni o'zingiznikiga moslab qo'ying
    const { staticModule } = store.state

    if (roleId === staticModule.roleApplicant) {
      this.Resolved = () => import('@/views/pages/user/users-list/UsersView.vue')
      return
    }

    if (roleId === staticModule.roleUniversity) {
      this.Resolved = () => import('@/views/Home.vue')
      return
    }
    if (roleId === staticModule.roleInnovation) {
      this.Resolved = () => import('@/views/pages/dashboard/Innovation.vue')
      return
    }

    if (roleId === staticModule.roleMinistry) {
      this.Resolved = () => import('@/views/MinistryHome.vue')
      return
    }

    // Tashkilot ma'sul rahbari faqat UzAsbo bilan ishlaydi
    if (roleId === staticModule.roleOrgHead) {
      this.Resolved = () => import('@/views/pages/uz-asbo/UzAsbo.vue')
      return
    }

    this.Resolved = () => import('@/views/SecondPage.vue')
  },
}
</script>
